import { useState } from "react";
import { Pagination } from "../models/general.model";

const INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 10,
  total: 0,
  pages: 0,
};

export const usePagination = () => {
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);

  const setPage = (page: number) => setPagination((prev) => ({ ...prev, page }));

  const setPaginationFromBackend = (data: Pagination) => setPagination(data);

  return { pagination, setPage, setPaginationFromBackend };
};
